(function() {
  'use strict';

  function initScrollHint() {
    const path = window.location.pathname;
    const isHome = path === '/' || path === '/en' || path === '/en/';
    if (!isHome) return;

    const style = document.createElement('style');
    style.textContent = `
      #cp-scroll-hint {
        position: fixed;
        bottom: 44px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 500;
        pointer-events: none;
        width: 40px;
        height: 40px;
      }

      #cp-scroll-hint svg {
        position: absolute;
        top: 0; left: 0;
        width: 40px; height: 40px;
        overflow: visible;
      }

      @keyframes cp-bob {
        0%   { transform: translateX(-50%) translateY(0px); }
        50%  { transform: translateX(-50%) translateY(4px); }
        100% { transform: translateX(-50%) translateY(0px); }
      }
      @keyframes cp-pulse {
        0%   { opacity: 0.18; }
        50%  { opacity: 0.5;  }
        100% { opacity: 0.18; }
      }
      #cp-scroll-hint.cp-idle {
        animation:
          cp-bob   4s ease-in-out infinite,
          cp-pulse 4s ease-in-out infinite;
      }
      #cp-scroll-hint.cp-gone { display: none !important; }

      .cp-arm {
        fill: none;
        stroke: rgba(255,255,255,0.4);
        stroke-width: 1;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
    `;
    document.head.appendChild(style);

    // Pijltje: minder puntig — hoek van ~120 graden (was ~90)
    // Armen beginnen meer gespreid zodat het zachter oogt
    const hint = document.createElement('div');
    hint.id = 'cp-scroll-hint';
    hint.innerHTML = `
      <svg viewBox="0 0 40 40" width="40" height="40">
        <path id="cp-arm-l" class="cp-arm" d="M 9 17 L 20 26"/>
        <path id="cp-arm-r" class="cp-arm" d="M 31 17 L 20 26"/>
      </svg>
    `;

    document.body.appendChild(hint);
    requestAnimationFrame(() => hint.classList.add('cp-idle'));

    let triggered = false;
    window.addEventListener('scroll', function onScroll() {
      if (triggered || window.scrollY <= 50) return;
      triggered = true;

      const armL = document.getElementById('cp-arm-l');
      const armR = document.getElementById('cp-arm-r');

      // Stop idle
      hint.classList.remove('cp-idle');
      hint.style.animation = 'none';
      hint.style.transform = 'translateX(-50%)';
      hint.style.opacity = '0.5';

      // Stap 1 — 0-900ms: armen drijven langzaam en rustig uit elkaar
      const startTime = performance.now();
      const splitDuration = 900;

      function splitArms(now) {
        const t = Math.min((now - startTime) / splitDuration, 1);
        // Zachte ease-in-out
        const ease = t < 0.5 ? 2*t*t : -1+(4-2*t)*t;

        // Linker arm — drijft kalm naar links en licht omhoog
        const lx1 = 9  - ease * 7;
        const ly1 = 17 - ease * 2;
        const lx2 = 20 - ease * 5;
        const ly2 = 26 + ease * 2;
        armL.setAttribute('d', `M ${lx1.toFixed(1)} ${ly1.toFixed(1)} L ${lx2.toFixed(1)} ${ly2.toFixed(1)}`);

        // Rechter arm — drijft kalm naar rechts en licht omhoog
        const rx1 = 31 + ease * 7;
        const ry1 = 17 - ease * 2;
        const rx2 = 20 + ease * 5;
        const ry2 = 26 + ease * 2;
        armR.setAttribute('d', `M ${rx1.toFixed(1)} ${ry1.toFixed(1)} L ${rx2.toFixed(1)} ${ry2.toFixed(1)}`);

        if (t < 1) requestAnimationFrame(splitArms);
      }
      requestAnimationFrame(splitArms);

      // Stap 2 — 900ms: alles begint langzaam te vervagen
      setTimeout(() => {
        hint.style.transition = 'opacity 1.4s ease';
        hint.style.opacity = '0';
      }, 900);

      // Stap 3 — 2800ms: element verwijderd
      setTimeout(() => {
        hint.classList.add('cp-gone');
        window.removeEventListener('scroll', onScroll);
      }, 2800);

    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollHint);
  } else {
    initScrollHint();
  }

})();
